// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Nepal */
const NP = /^(?:9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\d{7})$/;

export default NP;
